export const SET_LOADING = "SET_LOADING";

export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const UPDATE_USER_STATE = "UPDATE_USER_STATE";

export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS";
export const REFRESH_TOKEN_FAILURE = "REFRESH_TOKEN_FAILURE";
export const SET_REFRESH_TOKEN_INTERVAL_ID = "SET_REFRESH_TOKEN_INTERVAL_ID";

export const HANDLE_SSO_LOGIN = "HANDLE_SSO_LOGIN";
export const HANDLE_SSO_CALLBACK = "HANDLE_SSO_CALLBACK";

export const SET_ACTIVE_MENU = "SET_ACTIVE_MENU";

export const SET_SHOW_LOGOUT_ALERT = "SET_SHOW_LOGOUT_ALERT";

export const CLEAR_COOKIES_AND_SESSIONS = "CLEAR_COOKIES_AND_SESSIONS";

export const SET_SHOW_NOT_FOUND_PAGE = "SET_SHOW_NOT_FOUND_PAGE";

export const SET_MICROSOFT_USERS = "SET_MICROSOFT_USERS";

export const FETCH_MICROSOFT_USERS = "FETCH_MICROSOFT_USERS";
export const FETCH_MICROSOFT_USERS_SUCCESS = "FETCH_MICROSOFT_USERS_SUCCESS";
export const FETCH_MICROSOFT_USERS_FAILURE = "FETCH_MICROSOFT_USERS_FAILURE";
